/**
 * BombTile - Hazard that causes instant death
 */

import { BaseTile, TextureDescriptor } from "./BaseTile";
import { TILE } from "../constants/gameConstants";
import { TileIndex } from "../types";

export class BombTile extends BaseTile {
  constructor({ col, row, id }: { col: number; row: number; id?: string }) {
    super(id ?? `bomb-${col}-${row}`, col, row);
  }

  tileType(): TileIndex {
    return TILE.BOMB;
  }

  textureDescriptor(): TextureDescriptor {
    return { type: "png", path: "tiles/bomb.png" };
  }

  clone(): BombTile {
    const copy = new BombTile({ col: this.col, row: this.row, id: this.id });
    copy.sprite = this.sprite;
    return copy;
  }

  toJSON(): Record<string, any> {
    return { type: "bomb", id: this.id, col: this.col, row: this.row };
  }
}
